import React from "react";

function Football() {
  return <h1>Football Page</h1>;
}

export default Football;